import parse from "html-react-parser";
import { previewMensagem } from "../../resources/mensagem-personalizada";

const CelularMensagemMock = ({ mensagem, contexto, imageAnexo }) => {
  const bgMock = "https://public.siafevolution.com.br/bg-whatsapp.png";

  return (
    <div
      style={{
        background: "#f8f9fa",
        border: "0.35rem solid #474747",
        borderRadius: "30px",
        width: "220px",
        height: "400px",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          height: "24px",
          borderTopLeftRadius: "20px",
          borderTopRightRadius: "20px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          style={{
            background: "#474747",
            width: "3rem",
            height: "0.8rem",
            borderRadius: "9999px",
          }}
        ></div>
      </div>

      <div
        style={{
          padding: "16px",
          height: "calc(100% - 24px)",
          overflowY: "auto",
          backgroundColor: "#fafafa",
          background: `url(${bgMock})`,
        }}
      >
        <div
          style={{
            marginTop: "16px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              alignSelf: "flex-start",
              background: "white",
              borderRadius: "8px",
              padding: "8px 12px",
              maxWidth: "90%",
              marginBottom: "8px",
              wordBreak: "break-word",
              boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
            }}
          >
            <div style={{ whiteSpace: "pre-wrap", fontSize: "11px" }}>
              {imageAnexo?.fileData && (
                <img
                  src={imageAnexo.fileData}
                  alt="Preview"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    marginBottom: "1rem",
                  }}
                />
              )}
              {mensagem ? (
                parse(previewMensagem(mensagem, contexto))
              ) : (
                <span style={{ color: "#999" }}>
                  Escreva no editor de texto para ver sua mensagem aqui...
                </span>
              )}
            </div>
          </div>

          <div
            style={{
              alignSelf: "flex-start",
              marginLeft: "12px",
            }}
          >
            <span
              style={{
                color: "#667781",
                fontSize: "9px",
                display: "inline-block",
                marginTop: "-8px",
              }}
            >
              {new Date().toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              })}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CelularMensagemMock;
